import { render, staticRenderFns } from "./ProjectTemplateSelectPopupWrappable.vue?vue&type=template&id=47946827&scoped=true&lang=pug&"
import script from "./ProjectTemplateSelectPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplateSelectPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplateSelectPopupWrappable.vue?vue&type=style&index=0&id=47946827&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47946827",
  null
  
)

export default component.exports